export function calculateTreeDepth(treeData) {
  // 计算树的深度
  if (!treeData || treeData.length === 0) {
    return 0 // 如果节点数组为空，深度为0
  }
  let maxDepth = 0
  for (const node of treeData) {
    const childDepth = calculateTreeDepth(node.children)
    const currentDepth = childDepth + 1

    // 更新最大深度
    if (currentDepth > maxDepth) {
      maxDepth = currentDepth
    }
  }

  return maxDepth
}
